import {addClass, removeClass, once, getScrollBarWidth, on, off} from "./dom";
import "./mask.css";
export default {
  zIndex: 2e3,
  getZindex() {
    this.zIndex += 1;
    return this.zIndex;
  },
  timmer: null,
  stack: [],
  mask: null,
  pushStack(vm) {
    if (this.stack.indexOf(vm) > -1) {
      return;
    }
    const lastVm = this.stack[this.stack.length - 1];
    let maxZIndex = this.zIndex;
    if (lastVm) {
      maxZIndex = lastVm.zIndex + 2;
    }
    this.stack.push(vm);
    vm.zIndex = maxZIndex;
    if (vm.appendBody) {
      document.body.appendChild(vm.$el);
      vm.$once("destroy", () => {
        if (vm.$el.parentElement)
          document.body.removeChild(vm.$el);
      });
    }
    if (!this.mask && vm.mask) {
      const mask2 = document.createElement("div");
      this.mask = mask2;
      clearTimeout(this.timmer);
      addClass(mask2, "gd-mask gd-fade-enter gd-fade-enter-active");
      if (vm.appendBody) {
        document.documentElement.style.paddingRight = `${getScrollBarWidth()}px`;
        document.documentElement.style.overflow = "hidden";
        document.body.appendChild(mask2);
        mask2.style.position = "fixed";
      } else if (vm.$el.parentNode) {
        vm.$el.parentNode.appendChild(mask2);
        mask2.style.position = "absolute";
      }
      once(mask2, "transitionend", () => {
        removeClass(mask2, "gd-fade-enter-active");
      });
      this.timmer = setTimeout(() => removeClass(mask2, "gd-fade-enter-active"), 300);
      requestAnimationFrame(() => {
        removeClass(mask2, "gd-fade-enter");
      });
    }
    if (this.mask && vm.mask) {
      this.mask.style.zIndex = maxZIndex - 1 + "";
    }
    if (this.stack.length === 1) {
      this.handleEsc = this.handleEsc.bind(this);
      on(document.body, "keydown", this.handleEsc);
    }
  },
  popStack(vm) {
    if (!vm) {
      vm = this.stack[this.stack.length - 1];
    }
    if (!vm)
      return;
    if (this.stack.indexOf(vm) === -1)
      return;
    this.stack = this.stack.filter((v) => v !== vm);
    if (this.stack.filter((vm2) => vm2.mask).length === 0) {
      document.documentElement.style.paddingRight = "";
      document.documentElement.style.overflow = "";
    }
    if (this.mask) {
      const reverseStack = [...this.stack].reverse();
      const index = reverseStack.findIndex((vm2) => vm2.mask);
      if (index > -1) {
        const vm2 = reverseStack[index];
        this.mask.style.zIndex = vm2.zIndex - 1 + "";
      } else {
        const mask2 = this.mask;
        clearTimeout(this.timmer);
        addClass(mask2, "gd-mask gd-fade-leave-active");
        once(mask2, "transitionend", () => mask2.parentNode && mask2.parentNode.removeChild(mask2));
        setTimeout(() => mask2.parentNode && mask2.parentNode.removeChild(mask2), 300);
        window.requestAnimationFrame(() => addClass(mask2, "gd-fade-leave-to"));
        this.mask = null;
      }
    }
    if (this.stack.length === 0) {
      off(document.body, "keydown", this.handleEsc);
    }
  },
  handleEsc(e) {
    if (e.keyCode === 27 && this.stack.length) {
      const vm = this.stack[this.stack.length - 1];
      if (vm.keyborad && vm.cancel) {
        vm.cancel();
      }
    }
  }
};
